import React, { Component } from 'react'

import app from '../../../app.jsx'
import Loader from '../../../common/common/loader/loader.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class PageEmailConfirmation extends Component {
  constructor (props) {
    super(props)
    const params = new URLSearchParams(window.location.search)

    this.state = {
      token: params.get('token'),
      emailConfirmed: null
    }
  }

  componentDidMount () {
    if (this.state.token) {
      this.confirmEmail(this.state.token)
    }
  }

  async confirmEmail (confirmToken) {
    try {
      await app.service('/api/user/confirm').patch(null, { confirmToken })
      this.setState({ emailConfirmed: true })
    } catch (err) {
      console.warn(err)
      this.setState({ emailConfirmed: false })
    }
  }

  render () {
    const { token, emailConfirmed } = this.state

    if (token) {
      if (emailConfirmed === true) {
        app.redirect('/')
      } else {
        return (
          <div className='page-emailconfimation'>
            <div className='container'>
              <img alt='logo' className='logo' src='/images/common/rodeo_logo.svg' />
              <div className='content typo'>
                <h1 className='title'>
                  <IntlMessage ident='user.signupTeam.msgErrorTitle' />
                </h1>
                {emailConfirmed === null && <Loader size={60} color='#7abd9a' />}
                {emailConfirmed !== null && (
                  <div className='content'>
                    <p>
                      <IntlMessage ident='user.signupTeam.msgConfirmError' />
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )
      }
    }

    return (
      <div className='page-emailconfimation' style={this.state.contHgt}>
        <div className='container'>
          <img alt='logo' className='logo' src='/images/common/rodeo_logo.svg' />
          <div className='content typo'>
            <h1 className='title'>
              <IntlMessage ident='user.signupTeam.confirmTitle' />
            </h1>
            <div className='content'>
              <p>
                <IntlMessage ident='user.signupTeam.confirmInfo' />
              </p>
              <img alt='' className='letter-image' src='/images/common/letter.png' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PageEmailConfirmation
